/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React from 'react';
import T from 'i18n-react';
import cn from 'classnames';
import HorizontalScroll from 'components/New/HorizontalScroll';
import FilterItem from './Item';
import { getIsDefaultFilterItems } from './utils';
import classes from './FilterBar.module.scss';

const FilterBar = ({ items, onApply, onReset, onFilterReset, className }) => {
  const isDefaultFilter = getIsDefaultFilterItems(items.filter((item) => !item.asChild));
  const tItems = (items || []).map((item) => {
    if (item.asChild) {
      return {
        children: item.children,
      };
    }
    return {
      children: (
        <FilterItem
          className={item.className}
          valueWidth={item.valueWidth}
          width={item.width}
          key={item.key}
          item={item}
          defaultChecks={item.dropdown?.defaultChecks || []}
          defaultDate={item.dropdown?.defaultDate || null}
          onApply={(val, dateVal) => {
            onApply && onApply(item, val, dateVal);
          }}
          onReset={(val, dateVal) => {
            onReset && onReset(item, val, dateVal);
          }}
        />
      ),
    };
  });

  return (
    <>
      <div className={cn(classes.horizontalScrollWrapper, className)}>
        <HorizontalScroll items={tItems} onAction={() => {}} box className={classes.fbElement} />
        <FilterItem isReset isDisabled={isDefaultFilter} className={classes.resetItem}>
          <span className={classes.label} onClick={isDefaultFilter ? undefined : onFilterReset}>
            {T.translate('general.reset')}
          </span>
        </FilterItem>
      </div>
    </>
  );
};

export default FilterBar;
